import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING
} from "../store/types";
import { fetchBookingLocations } from '../actions/locationactions';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { callSecureFunction } from '../other/secureFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { addActualsToBooking, saveAddresses, updateDriverQueue } from "../other/sharedFunctions";
import { get, onValue, update, off, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL, uploadString } from "firebase/storage";

export const fetchBookings = () => (dispatch) => {

  const {
    bookingListRef,
  } = firebase;

  const userInfo = store.getState().auth.profile;
  if (!userInfo?.uid || !userInfo?.usertype) {
    dispatch({
      type: FETCH_BOOKINGS_SUCCESS,
      payload: {
        bookings: [],
        active: [],
        tracked: null,
      },
    });
    return;
  }

  dispatch({
    type: FETCH_BOOKINGS,
    payload: null,
  });

  const listRef = bookingListRef(userInfo.uid, userInfo.usertype);
  off(listRef);
  onValue(listRef, (snapshot) => {
    try {
      if (snapshot.val()) {
        const data = snapshot.val();
        const active = [];
        let tracked = null;
        const bookings = Object.keys(data)
          .map((i) => {
            const row = { ...data[i], id: i };
            row.pickupAddress = row.pickup?.add || '';
            row.dropAddress = row.drop?.add || '';
            row.discount = row.discount ? row.discount : 0;
            row.cashPaymentAmount = row.cashPaymentAmount ? row.cashPaymentAmount : 0;
            row.cardPaymentAmount = row.cardPaymentAmount ? row.cardPaymentAmount : 0;
            return row;
          });
        for (let i = 0; i < bookings.length; i++) {
          if (['PAYMENT_PENDING','NEW', 'ACCEPTED', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING', 'PAID'].indexOf(bookings[i].status) != -1) {
            active.push(bookings[i]);
          }
          if ((['ACCEPTED', 'ARRIVED', 'STARTED'].indexOf(bookings[i].status) != -1) && userInfo.usertype == 'driver') {
            tracked = bookings[i];
            fetchBookingLocations(tracked.id)(dispatch);
          }
        }
        dispatch({
          type: FETCH_BOOKINGS_SUCCESS,
          payload: {
            bookings: bookings.reverse(),
            active: active,
            tracked: tracked
          },
        });
      } else {
        // Sin reservas aún no es un error: evita vaciar `active` y provocar
        // redirecciones prematuras en BookedCab / "Mis reservas" vacío.
        dispatch({
          type: FETCH_BOOKINGS_SUCCESS,
          payload: {
            bookings: [],
            active: [],
            tracked: null,
          },
        });
      }
    } catch (error) {
      console.error('[fetchBookings] parse error', error);
      dispatch({
        type: FETCH_BOOKINGS_FAILED,
        payload: error?.message || 'fetch_bookings_failed',
      });
    }
  }, (error) => {
    console.error('[fetchBookings] listener error', error);
    dispatch({
      type: FETCH_BOOKINGS_FAILED,
      payload: error?.message || 'fetch_bookings_failed',
    });
  });
};

export const updateBooking = (booking) => async (dispatch) => {

  const {
    auth,
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
    userRatingsRef
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  
  if (booking.status == 'PAYMENT_PENDING') {
    update(singleBookingRef(booking.id),booking);
  }
  if (booking.status == 'NEW' || booking.status == 'ACCEPTED') {
    update(singleBookingRef(booking.id), updateDriverQueue(booking));
  }
  if (booking.status == 'ARRIVED') {
    let dt = new Date();
    booking.driver_arrive_time = dt.getTime().toString();
    update(singleBookingRef(booking.id),booking);
    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_near,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }
  }
  
  if (booking.status == 'STARTED') {
    let dt = new Date();
    let localString = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    let timeString = dt.getTime();
    booking.trip_start_time = localString;
    booking.startTime = timeString;
    update(singleBookingRef(booking.id),booking);

    const driverLocation = store.getState().gpsdata.location;
    
    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'STARTED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_journey_msg + booking.reference,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
      }
   }

  if (booking.status == 'REACHED') {

    const driverLocation = store.getState().gpsdata.location;

    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });

    let address = await saveAddresses(booking,driverLocation);

    let bookingObj = await addActualsToBooking(booking, address, driverLocation);
    update(singleBookingRef(booking.id),bookingObj);

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }
  }

  if (booking.status == 'PENDING') {
    update(singleBookingRef(booking.id),booking);
    update(singleUserRef(booking.driver), { queue: false });
  }
  if (booking.status == 'PAID') {
    if(booking.booking_from_web){
      booking.status = 'COMPLETE';
    }
    update(singleBookingRef(booking.id), booking);
    if(booking.driver == auth.currentUser.uid && (booking.prepaid || booking.payment_mode == 'cash' || booking.payment_mode == 'wallet')){
      update(singleUserRef(booking.driver), { queue: false });
    }

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.success_payment,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }

    if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }
    }

  if (booking.status == 'COMPLETE') {
    update(singleBookingRef(booking.id), booking);
    if (booking.rating) {
      if(booking.driver_token){
        const lang = store.getState().languagedata.defaultLanguage || {};
        const customerName = (booking.customer_name || '').trim() || lang.a_customer || 'Un cliente';
        const ratingStars = booking.rating.toString();
        let msg = (lang.received_rating_from_user || '{name} te calificó con {rating} estrellas.')
            .replace('{name}', customerName)
            .replace('{rating}', ratingStars)
            .replace('X', ratingStars);
        const tip = parseFloat(booking.tipamount);
        if (tip > 0 && settings && settings.symbol) {
          const tipMsg = (lang.tip_received_from_user || '{name} te dio una propina de {amount}.')
            .replace('{name}', customerName)
            .replace('{amount}', settings.symbol + ' ' + tip);
          msg = tipMsg + ' ' + msg;
        }
        if (booking.feedback) {
          msg += ' "' + booking.feedback + '"';
        }
        RequestPushMsg(
          booking.driver_token,
          {
              title: lang.tip_rating_title || lang.notify_rating_title || 'Calificación recibida',
              msg,
              screen: 'RatingReceived',
              params: {
                bookingId: booking.id,
                rating: booking.rating,
                feedback: booking.feedback || '',
                tipamount: booking.tipamount || 0,
                customer_name: booking.customer_name || '',
              }
          });
      }
      onValue(userRatingsRef(booking.driver), snapshot => {
        let ratings = snapshot.val();
        let rating;
        if(ratings){
          let sum = 0;
          const arr = Object.values(ratings);
          for (let i = 0; i< arr.length ; i++){
            sum = sum + arr[i].rate
          }
          sum = sum + booking.rating;
          rating = parseFloat(sum / (arr.length + 1)).toFixed(1);
        }else{
          rating =  booking.rating;
        }
        update(singleUserRef(booking.driver),{rating: rating});
        push(userRatingsRef(booking.driver), {
          user: booking.customer,
          rate: booking.rating,
          bookingId: booking.id
        });
      }, { onlyOnce: true});
    }
  }
};

// Antifraude (#13): penaliza a quien cancela una reserva YA aceptada fuera de la
// ventana de gracia (1 min). Multa + bloqueo temporal escalando por reincidencia.
// El usuario que cancela se penaliza a sí mismo (escribe sobre su propio nodo,
// por lo que respeta las reglas de seguridad). Aplica a conductor y cliente.
const applyCancellationPenalty = (booking) => {
  try {
    const state = store.getState();
    const settings = (state.settingsdata && state.settingsdata.settings) || {};
    if (settings.disableCancellationPenalty) return;
    const me = state.auth && state.auth.profile;
    if (!me || !me.uid) return;

    const penalizable = ['ACCEPTED', 'ARRIVED', 'STARTED'].indexOf(booking.status) !== -1;
    if (!penalizable) return;

    callSecureFunction('apply_cancellation_penalty', {
      bookingId: booking.id,
      bookingStatus: booking.status,
      acceptedAt: booking.acceptedAt || 0,
    }).then((result) => {
      if (!result || result.skipped || !me.pushToken) return;
      const sym = settings.symbol || '';
      let msg = 'Multa por cancelación descontada de tu billetera: -' + sym + result.fee + '.';
      if (result.offenses >= 3 && me.usertype === 'driver') {
        msg = 'Has acumulado 3 cancelaciones sin justa causa. Tu cuenta de conductor fue desactivada permanentemente y no podrás registrarte de nuevo.';
      }
      RequestPushMsg(me.pushToken, {
        title: store.getState().languagedata.defaultLanguage.notification_title,
        msg,
        screen: result.offenses >= 3 && me.usertype === 'driver' ? 'Settings' : 'Wallet',
      });
    }).catch((e) => {
      console.log('applyCancellationPenalty error', e);
    });
  } catch (e) {
    console.log('applyCancellationPenalty error', e);
  }
};

export const cancelBooking = (data) => (dispatch) => {
  const {
    singleBookingRef,
    singleUserRef,
    requestedDriversRef
  } = firebase;

  dispatch({
    type: CANCEL_BOOKING,
    payload: data,
  });

  // Aplica la penalidad antifraude al usuario que cancela (si corresponde).
  applyCancellationPenalty(data.booking);

  update(singleBookingRef(data.booking.id),{
    status: 'CANCELLED',
    reason: data.reason,
    cancelledBy: data.cancelledBy
  }).then(() => {
    if (data.booking.driver && (data.booking.status === 'NEW' || data.booking.status === 'ACCEPTED' || data.booking.status === 'ARRIVED')) {
      update(singleUserRef(data.booking.driver),{ queue: false });
        if(data.booking.driver_token){
        RequestPushMsg(
          data.booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.notify_partner_cancelled_booking
                || 'El socio canceló el servicio. Es posible que debas ofertar el viaje nuevamente.',
              screen: 'BookedCab',
              params: { bookingId: data.booking.id }
          });
        }

        if(data.booking.customer_token){
          RequestPushMsg(
            data.booking.customer_token,
            {
                title: store.getState().languagedata.defaultLanguage.notification_title,
                msg: store.getState().languagedata.defaultLanguage.booking_cancelled + data.booking.id,
                screen: 'BookedCab',
                params: { bookingId: data.booking.id }
            });
        }
   }
    if (data.booking.status === 'NEW') {
      remove(requestedDriversRef(data.booking.id));
    }
  });
};

export const updateBookingImage = (booking, imageType, imageBlob) => (dispatch) => {
  const   {
    singleBookingRef,
    bookingImageRef
  } = firebase;
  uploadBytesResumable(bookingImageRef(booking.id,imageType), imageBlob).then(() => {
    imageBlob.close()
    return getDownloadURL(bookingImageRef(booking.id,imageType))
  }).then((url) => {
    if(imageType == 'pickup_image'){
      booking.pickup_image = url;
    }
    if(imageType == 'deliver_image'){
      booking.deliver_image = url;
    }
    update(singleBookingRef(booking.id), booking);
    dispatch({
      type: UPDATE_BOOKING,
      payload: booking,
    });
  })
};

// Anti-theft evidence for tows: uploads the photos of the vehicle being towed
// (plus plate and condition notes) at the pickup and drop phases and stores
// them on the booking so the customer and admin can audit the handover.
export const uploadBookingEvidence = (booking, phase, media, meta) => async (dispatch) => {
  const {
    singleBookingRef,
    bookingImageRef
  } = firebase;
  const urls = [];
  const items = media || [];
  let lastError = null;
  const cleanBase64 = (raw) => {
    if (!raw || typeof raw !== 'string') return null;
    const idx = raw.indexOf('base64,');
    return idx >= 0 ? raw.slice(idx + 7) : raw;
  };
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const r = bookingImageRef(booking.id, `evidence_${phase}_${i}`);
    // Subida en cascada (4 estrategias) para evitar "Error al subir imagen"
    // en cualquier dispositivo iOS/Android:
    //   1) base64 (lo mas confiable en iOS)  -> uploadString
    //   2) blob ya preparado                 -> uploadBytes
    //   3) el item es directamente un blob    -> uploadBytes
    //   4) ultimo recurso: descargar el uri   -> fetch().blob() -> uploadBytes
    let uploaded = false;
    if (!uploaded && item && item.base64) {
      try { await uploadString(r, cleanBase64(item.base64), 'base64', { contentType: 'image/jpeg' }); uploaded = true; }
      catch (e) { lastError = e; }
    }
    if (!uploaded && item && item.blob) {
      try {
        await uploadBytesResumable(r, item.blob);
        try { if (item.blob.close) item.blob.close(); } catch (e2) { }
        uploaded = true;
      } catch (e) { lastError = e; }
    }
    if (!uploaded && item && (item._data || item.size != null)) {
      try {
        await uploadBytesResumable(r, item);
        try { if (item.close) item.close(); } catch (e2) { }
        uploaded = true;
      } catch (e) { lastError = e; }
    }
    if (!uploaded && item && item.uri) {
      try {
        const resp = await fetch(item.uri);
        const b = await resp.blob();
        await uploadBytesResumable(r, b, { contentType: 'image/jpeg' });
        try { if (b.close) b.close(); } catch (e2) { }
        uploaded = true;
      } catch (e) { lastError = e; }
    }
    if (!uploaded) continue;
    const url = await getDownloadURL(r);
    urls.push(url);
  }
  // Si habia fotos pero ninguna subio, propagamos el error para mostrar el aviso.
  if (items.length > 0 && urls.length === 0) {
    throw (lastError || new Error('evidence_upload_failed'));
  }
  const updated = { ...booking };
  updated.evidence = { ...(booking.evidence || {}) };
  updated.evidence[phase] = {
    photos: urls,
    plate: meta && meta.plate ? meta.plate : '',
    notes: meta && meta.notes ? meta.notes : '',
    at: new Date().getTime()
  };
  await update(singleBookingRef(booking.id), updated);
  dispatch({
    type: UPDATE_BOOKING,
    payload: updated,
  });
  return updated;
};

export const forceEndBooking = (booking) => async (dispatch) => {

  const {
    trackingRef,
    singleBookingRef,
    singleUserRef,
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });
  
  if (booking.status == 'STARTED') {

    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: booking.drop.lat,
      lng: booking.drop.lng
    });

    const end_time = new Date();
    const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
    const totalTimeTaken = Math.abs(Math.round(diff));
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        });
    }

    update(singleUserRef(booking.driver),{ queue: false });

    if(booking.prepaid){
      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
      }

      if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          });
        }
      booking.status = 'PAID';
    } else{
      booking.status = 'PENDING';
    }

    update(singleBookingRef(booking.id), booking);
  }
};